export const MAX_SITES = 5;

export const hostOf = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/^[a-z]+:\/\//, "")
    .replace(/[/?#].*$/, "")
    .replace(/:\d+$/, "")
    .replace(/\.$/, "");

export const GUIDES = [
  {
    key: "wordpress",
    label: "WordPress",
    steps: [
      "Open the page in the WordPress editor.",
      "Add a Custom HTML block where the buyers should appear.",
      "Paste the snippet and select Update.",
    ],
    note: "WordPress.com sites on the free and Personal plans remove scripts. Use the Plain iframe tab there.",
  },
  {
    key: "squarespace",
    label: "Squarespace",
    steps: [
      "Edit the page and add a Code block where the buyers should appear.",
      "Paste the snippet and leave Display Source off.",
      "Select Apply, then Save.",
    ],
    note: "Squarespace runs scripts in Code blocks on Core plans and above. On Personal, link to your hosted page.",
  },
  {
    key: "wix",
    label: "Wix",
    steps: [
      "In the Wix Editor, select Add Elements, then Embed Code, then Embed HTML.",
      "Choose Code and paste the Plain iframe line.",
      "Drag the element taller so every card shows, then Publish.",
    ],
    note: "Wix keeps embeds in a fixed-size box, so set the height once after you paste.",
  },
  {
    key: "webflow",
    label: "Webflow",
    steps: [
      "Drag an Embed element onto the page where the buyers should appear.",
      "Paste the snippet and select Save & Close.",
      "Publish the site.",
    ],
    note: "",
  },
  {
    key: "custom",
    label: "Custom site",
    steps: [
      "Paste the snippet into the page HTML where the buyers should appear.",
      "Deploy the page as usual.",
      "Open the page once. Step 4 turns green within a minute.",
    ],
    note: "The frame grows to fit its cards, so it needs no height and has no inner scrollbar.",
  },
];

export const SNIPPETS = [
  { key: "script", label: "Script" },
  { key: "iframe", label: "Plain iframe" },
  { key: "hosted", label: "Hosted page" },
];

export const dateOf = (value) =>
  value ? new Date(value).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "";

export const lastSeenOf = (sites) =>
  (sites || [])
    .filter((site) => site.lastSeenAt)
    .sort((a, b) => new Date(b.lastSeenAt) - new Date(a.lastSeenAt))[0] || null;

export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    const area = document.createElement("textarea");
    area.value = text;
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand?.("copy");
    area.remove();
    return Boolean(ok);
  }
};
